import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUsers } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import { useEffect } from "react";
const MembersCommunitySection = ({ setActiveSection }) => {
  useEffect(() => {
    setActiveSection("member community");
  }, [setActiveSection]);
  return (
    <div className="community-section member-section">
      <FontAwesomeIcon icon={faUsers} className="section-icon" />
      <h1>For Members</h1>
      <p>
        Seed to Tree Online Academy provides a multitude of benefits for
        members, including:
      </p>
      <ul>
        <li>
          <strong>Access to High-Quality Courses:</strong> Members gain access
          to a diverse catalog of high-quality courses curated by experts.
        </li>
        <li>
          <strong>Certification and Recognition:</strong> Receive widely
          recognized certifications upon course completion.
        </li>
        <li>
          <strong>Regular Updates and New Content:</strong> Stay informed with
          newsletters about new courses and workshops.
        </li>
        <li>
          <strong>Discounts and Special Offers:</strong> Enjoy 15% discounts on
          all courses and events. Membership costs 300 rupees.
        </li>
      </ul>
      {/* <iframe
        src="https://forms.gle/6J8EWRBuPRhjPbJQ6"
        title="Member Application Form"
        width="100%"
        height="500px"
        frameBorder="0"
        allow="fullscreen"
      ></iframe> */}

      <Link to="https://forms.gle/6J8EWRBuPRhjPbJQ6" >
        Fill Members From
      </Link>
    </div>
  );
};

export default MembersCommunitySection;
